module.exports = __webpack_public_path__ + "static/media/chicken-icon.76cb2a7c.png";